import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

import { sendEvent } from "js/utils/google-analytics";

const Context = createContext();

export const AttributionBacklinkProvider = ({
    iconTitle,
    creatorName,
    iconId,
    slugWithId,
    children
}) => {
    /* ----------------------------- DOWNLOAD COUNT ----------------------------- */

    const [downloadCount, setDownloadCount] = useState(0);
    const incrementDownloadCount = () => setDownloadCount(downloadCount + 1);

    /* ---------------------------- ATTRIBUTION COPY ---------------------------- */

    const [attributionCopied, setAttributionCopied] = useState(false);
    const resetAttributionCopy = () => setAttributionCopied(false);

    const titleSlug = slugWithId
        .split("-")
        .slice(0, -1)
        .join("-");

    const copyAttribution = async () => {
        const copyText = `${iconTitle} by ${creatorName} from <a href="https://thenounproject.com/browse/icons/term/${titleSlug}/" target="_blank" title="${iconTitle} Icons">Noun Project</a>`;

        try {
            if (!navigator.clipboard) throw new Error();

            await navigator.clipboard.writeText(copyText);
            setAttributionCopied(true);
            sendEvent("icon", "copy.attribution", iconId);
        } catch (error) {
            console.error("Unable to copy attribution text to clipboard");
        }
    };

    /* --------------------------- THANK YOU ANIMATION -------------------------- */

    const [runningThankYouAnimation, setRunningThankYouAnimation] = useState(
        false
    );

    const startThankYouAnimation = () => {
        setRunningThankYouAnimation(true);
    };

    const finishThankYouAnimation = () => {
        setRunningThankYouAnimation(false);
    };

    const contextValues = {
        // ATTRIBUTION COPY
        attributionCopied,
        resetAttributionCopy,
        copyAttribution,
        // ICON INFO
        iconTitle,
        creatorName,
        titleSlug,
        // DOWNLOAD COUNT
        downloadCount,
        incrementDownloadCount,
        // THANK YOU ANIMATION
        runningThankYouAnimation,
        startThankYouAnimation,
        finishThankYouAnimation
    };

    return (
        <Context.Provider value={contextValues}>{children}</Context.Provider>
    );
};

AttributionBacklinkProvider.propTypes = {
    iconTitle: PropTypes.string.isRequired,
    creatorName: PropTypes.string.isRequired,
    iconId: PropTypes.string.isRequired,
    slugWithId: PropTypes.string.isRequired
};

export const useAttributionBacklink = () => {
    const context = useContext(Context);

    if (context === undefined) {
        throw new Error(
            "useAttributionBacklink must be used within an AttributionBacklinkProvider"
        );
    }

    return context;
};
